export class NotificationsSearchModel {
    pageData = [];
    pageNumber = 0;
    pageSize = 0;
}
